import { render, staticRenderFns } from "./OrderHistoryDetail.vue?vue&type=template&id=2b6c6bf9&scoped=true&"
import script from "./OrderHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryDetail.vue?vue&type=style&index=0&id=2b6c6bf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c6bf9",
  null
  
)

export default component.exports